import { render, staticRenderFns } from "./QRcode.vue?vue&type=template&id=6367ec74&scoped=true"
import script from "./QRcode.vue?vue&type=script&lang=js"
export * from "./QRcode.vue?vue&type=script&lang=js"
import style0 from "./QRcode.vue?vue&type=style&index=0&id=6367ec74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6367ec74",
  null
  
)

export default component.exports